(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["FAQ"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".faq-details").forEach((details) => {
      const iconClosed = details.querySelector(".faq-icon-closed");
      const iconOpen = details.querySelector(".faq-icon-open");

      if (details.open) {
        iconClosed.style.display = "none";
        iconOpen.style.display = "inline";
      }

      details.addEventListener("toggle", () => {
        if (details.open) {
          iconClosed.style.display = "none";
          iconOpen.style.display = "inline";
        } else {
          iconClosed.style.display = "inline";
          iconOpen.style.display = "none";
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
